import React from 'react';
import { Input, Button, Select, Textarea, PaperClip, Table, Tooltip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ProductService } from 'services';
import { AddIcon, TrashIcon } from 'assets/icons';

interface Props {
	onClose?: any;
}

class Shipping extends React.Component<Props> {

	state = {
		shipping: [],
		types: [],
		headers: [
			'Nombre',
			'Tipo',
			'Precio',
			'Moneda',
			'Descripción',
			'Acciones'
		]
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ProductService.getShipping();
		this.setState({
			shipping: res.shipping || [],
			types: res.types || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		const item = this.state.shipping.find((i: any) => !i.name || !i.price || !i.type_id || !i.currency);

		if (item) {
			Globals.showError("Por favor, ingrese todos los datos para continuar");
			return;
		}

		await ProductService.saveShipping({
			shipping: JSON.stringify(this.state.shipping)
		});
		Globals.showSuccess("Se ha guardado la configuración correctamente");
	}

	add = () => {
		let shipping: any = [...this.state.shipping];
		shipping.push({
			name: '',
			type_id: '',
			price: '',
			description: '',
			currency: ''
		});
		this.setState({
			shipping
		});
	}

	changeItem = (e: any, index: number) => {
		e.preventDefault();
		let shipping: any = [...this.state.shipping];
		shipping[index][e.target.name] = e.target.value;
		this.setState({
			shipping
		});
	}

	delete = (e: any, index: number) => {
		e.preventDefault();
		let shipping: any = [...this.state.shipping];
		shipping.splice(index,1);
		this.setState({
			shipping
		});
	}
	
	render() {
		return (
			<div id="client-shipping">
				<div className="text-right">
					<button className="btn add-btn" onClick={ this.add }>
						<img src={ AddIcon } />
						<p>Nuevo</p>
					</button>
				</div>
				<Table data={ this.state.shipping.length } header={ this.state.headers }>
					{
						this.state.shipping.map((item: any, index: number) => {
							return (
								<tr>
									<td>
										<Input
											value={ item.name }
											name="name"
											placeholder="Nombre"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Select
											color="white"
											placeholder="Seleccionar"
											name="type_id"
											onChange={ (e: any) => this.changeItem(e,index) }
											value={ item.type_id }
											options={ this.state.types.map((i: any) => {
												return {
													label: i.name,
													value: i.id
												}
											}) } />
									</td>
									<td>
										<Input
											type="decimal"
											value={ item.price }
											name="price"
											placeholder="Precio"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Input
											value={ item.currency }
											name="currency"
											placeholder="Moneda"
											onChange={ (e: any) => this.changeItem(e,index) } />
									</td>
									<td>
										<Textarea
											rows={ 3 }
											value={ item.description }
											placeholder="Descripción (Opcional)"
											name="description"
											onChange={ (e: any) => this.changeItem(e, index) } />
									</td>
									<td>
										<Tooltip title="Eliminar">
											<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,index) }>
												<img src={ TrashIcon } />
											</a>
										</Tooltip>
									</td>
								</tr>
							)
						})
					}
				</Table>
				<div className="text-center">
					<Button className="btn-send" type="submit" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default Shipping;